import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';

/**
 * Carousel generico drag-scroll basato su Embla, riusabile da più blocchi
 * (galleria, recensioni, dintorni…).
 *
 * Markup atteso:
 *   <div data-tm-carousel data-loop="true" data-autoplay="off"
 *        data-autoplay-delay="4000" data-autoplay-speed="2">
 *     <div data-carousel-viewport>
 *       <div data-carousel-track>
 *         <div class="tm-carousel__slide">…</div>
 *       </div>
 *     </div>
 *   </div>
 *
 * data-loop: riparte da capo (default true). data-autoplay: 'off' | 'step'
 * (avanza a scatti ogni delay ms) | 'scroll' (scorrimento continuo lento).
 * Entrambe le modalità si fermano sul mouse e sono ignorate in reduced-motion.
 *
 * @param {ParentNode} root Ambito in cui cercare i carousel.
 */
export function initCarousels( root = document ) {
	const reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	root.querySelectorAll( '[data-tm-carousel]' ).forEach( ( el ) => {
		const viewport = el.querySelector( '[data-carousel-viewport]' );
		if ( ! viewport || viewport.dataset.emblaReady ) {
			return;
		}

		const mode    = el.dataset.autoplay || 'off';
		const plugins = [];
		if ( ! reduce && 'step' === mode ) {
			const delay = parseInt( el.dataset.autoplayDelay, 10 ) || 4000;
			plugins.push(
				Autoplay( { delay, stopOnMouseEnter: true, stopOnInteraction: false } )
			);
		} else if ( ! reduce && 'scroll' === mode ) {
			const speed = parseFloat( el.dataset.autoplaySpeed ) || 2;
			plugins.push(
				AutoScroll( { speed, startDelay: 0, stopOnMouseEnter: true, stopOnInteraction: false } )
			);
		}

		const embla = EmblaCarousel(
			viewport,
			{
				// Lo scorrimento continuo necessita il loop per essere senza fine.
				loop: el.dataset.loop !== 'false' || 'scroll' === mode,
				dragFree: true,
				align: 'start',
			},
			plugins
		);

		// Cursor grab/grabbing durante il trascinamento.
		embla.on( 'pointerDown', () => el.classList.add( 'is-dragging' ) );
		embla.on( 'pointerUp', () => el.classList.remove( 'is-dragging' ) );

		viewport.dataset.emblaReady = 'true';
		// Esposto per eventuale reinit/destroy da altri moduli.
		viewport.__embla = embla;
	} );
}
